import {
  CoreItemBackend,
  CoreItemType,
  VertexRelationship,
} from '../../../../frontend/src/app/core/core-item/core-item';
import { BasicAction } from '../basic-action';
import { IdRequest } from '../request-response';
import { ResourceName } from '../resource-name';

export const CoreItemGate = {
  resource: ResourceName.coreItem,
  actions: {
    getItem: BasicAction.getItem,
    getItemListByIdList: 'get-item-list-by-id-list',
    getItemListByTypeList: 'get-item-list-by-type-list',

    update: BasicAction.update,

    batchWriteMetadataOrRelationList: 'batch-write-metadata-or-relation-list',
  },
};

export type CoreItemGateActionTypes = {
  update: {
    request: CoreItemBackend;
    response: CoreItemBackend;
  };
  getItem: {
    request: IdRequest;
    response: CoreItemBackend;
  };
  getItemListByTypeList: {
    request: GetItemListByTypeListRequest;
    response: CoreItemBackend[];
  };
  getItemListByIdList: {
    request: { id: string; sk: string }[];
    response: CoreItemBackend[];
  };
  batchWriteMetadataOrRelationList: {
    request: BatchWriteMetadataOrRelationListRequest;
    response: BatchWriteMetadataOrRelationListResponse;
  };
};

export interface GetItemListByTypeListRequest {
  workspaceId: string;
  typeList: CoreItemType[];
  parentId?: string;
}

export interface BatchWriteMetadataOrRelationListRequest {
  workspaceId: string;
  addRelationList?: VertexRelationship[];
  deleteRelationList?: VertexRelationship[];
  addMetadataList?: { type: CoreItemType; metadata: Partial<CoreItemBackend> }[];
  deleteMetadataList?: { id: string; sk: string }[];
  updateMetadataList?: CoreItemBackend[];
}

export interface BatchWriteMetadataOrRelationListResponse {
  addedMetadataList: CoreItemBackend[];
  addedRelationList: VertexRelationship[];
  updatedMetadataList?: CoreItemBackend[];
}
